import React, { useRef } from 'react';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/prop-types
const BulkUploadButton = ({ onChange, label }) => {
  const bulkUploadInputRef = useRef(null);
  return (
    <>
      <input
        ref={bulkUploadInputRef}
        type='file'
        className='hidden'
        onChange={onChange}
        accept='.csv,.xlsx,.xls'
      />
      <button
        type='button'
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        onClick={() => bulkUploadInputRef?.current?.click()}
        className='btn btn-primary pull-right'
      >
        {label}
      </button>
    </>
  );
};

export default BulkUploadButton;
